window.EmailCssHeaderID;
window.EmailCssFooterID;
window.saveEmailtype;
(function ($) {
	RVwys.plugin['savemail'] = true;
	$(document).bind('editorReady',function(){

		$('#savemail').click(function(){
			// console.pop.warning({text: 'coming soon...'});
			// return;
			window.saveEmailtype = 'saveall';
			new savemailAsync();

		});
		// save header
		RVwys.saveEmailHeader = function(){
			window.saveEmailtype = 'header';
			new savemailAsync();
		}

		// save header
		RVwys.saveEmailFooter = function(){
			window.saveEmailtype = 'footer';
			new savemailAsync();
		}

	});

	class savemailAsync {
		constructor() {

			this.header_content = parent.$('#frameBody').contents().find('#selected_header').clone();
			this.header_edit;
			this.header_view;

			this.content = RVwys.save.getEmailContent();
			this.content_edit;
			this.content_view;

			this.footer_content = parent.$('#frameBody').contents().find('#selected_footer').clone();
			this.footer_edit;
			this.footer_view;

			this.arrCss = [];

			this.init();

		}

		async init (){

			var isBefore =  await this.before();
			var isSave =  await this.save();
			var isAfter =  await this.complete();

		}

		async before(){
			//			var res = false;
			//			no await
			this.arrCss = this.replaceCss();
			//			await
			var isRemove = await this.removeData();
			var isrep = await this.replaceData();

			/*if(this.arrImg&& isRemove &&isrep ) {
				return res;

			}*/
		}

		async save(){
			var isencode = await this.encodeData();
			var email_id = ($('#email_id').length == 1) ? $('#email_id').val() : parent.$('#email_id').val();

			var oThis = this;

			var overlaypanel = $('<div class="overlaypanel">'
					+'<img class="loading" src="'+parent.wex.url.WYS_IMG_URL+'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />'
					+'</div>').css({
						'width':$('body').width(),
						'height':$('body').height()
					});

			$('body').prepend(overlaypanel);
			var saveAjax = await $.ajax({
						type: 'POST',
						url:'/admin/email/update/savemail',
            data:{
             savetype : saveEmailtype,
             email_id : email_id,
             email_type : $('#isType').val(),
             css_path : this.arrCss,
             // Header
			 		 	 header_content_edit : this.header_edit,
             header_content_view : this.header_view,
						 header_custom : $('#header_custom').val(),
						 header_style : window.EmailCssHeaderID,
             // Content
						 content_edit : this.content_edit,
             content_view : this.content_view,
             // Footer

						 footer_content_edit : this.footer_edit,
             footer_content_view : this.footer_view,
						 footer_custom : $('#footer_custom').val(),
						 footer_style : window.EmailCssFooterID,

            },
            headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
						error: function (jqXHR, exception) {
							 //console.log(jqXHR.responseJSON.errors.header_content_edit[0]);
							 console.pop.error({text: jqXHR.responseJSON.message});

							 setTimeout(function(){

									oThis.afterError();

								},1000);
						},
						success :function(data) {
							parent.$('.overlaypanel').remove();
							parent.$('.overlayfooter').remove();
							// if have error response all error : pnotice only one success
//							 console.log(data);
							const err = $.map(data,function(el) {
									return el.status;
								}).indexOf('error');
							if(!!~err) {
								$.each(data, function( i, v ) {
										if(v.status == 'error'){

											console.error(v.response_msg);

											console.pop.error({
												text: 'Save Fail',
												delay:3000
											});
										}
								});
							}else{
								$('#header_custom').val('');
								$('#footer_custom').val('');
								console.pop.success({
									text: 'Saved Success',
									delay:3000
								});
							}

							oThis.afterSuccess();
						}


				});
		}

		async complete(){
				console.log('-- Saveasync complete --');
		}
		async afterSuccess(){
			console.log('-- Saveasync afterSuccess --');
		}

		replaceCss(){

			var links = window.document.getElementsByTagName('link');
      var array_css = [];
			$(links).each(function() {
				const debug = $(this).attr('href').indexOf('_debugbar');
				const cssPath = $(this).attr('href').indexOf('.css');

				if(debug == -1 && cssPath != -1){
					array_css.push($(this).attr('href'));
				}
      });
			return array_css;
		}

		async removeData(){

			 var isEle = await this.removeElement();
			 var isClass = await this.removeClass();

			 return
		}

	 	async replaceData(){
			 await this.replaceElement();
			 await this.replaceTEXT();
		}

		async removeElement(){

			var header = this.removeEleHeader();
			var content = this.removeEleContent();
			var footer = this.removeEleFooter();

			await header;
			await content;
			await footer;

		}

		async removeClass(){

			var header = this.removeClassHeader();
			var content = this.removeClassContent();
			var footer = this.removeClassFooter();

			await header;
			await content;
			await footer;

	  }

		async replaceElement(){

			var header = this.replaceEleHeader();
			var content = this.replaceEleContent();


			 await header;
			 await content;

		}

		async replaceTEXT(){
				var header = this.replaceTxtHeader();
				var content = this.replaceTxtContent();
				var footer = this.replaceTxtFooter();

				await header;
				await content;
				await footer;
		}
//		encode
async encodeData(){

	this.header_edit =  RVwys.save.encodeHTMLentities(this.header_edit);
	this.header_view = RVwys.save.encodeHTMLentities(this.header_view);

	this.content_edit =  RVwys.save.encodeHTMLentities(this.content_edit);
	this.content_view =  RVwys.save.encodeHTMLentities(this.content_view);

	this.footer_edit =  RVwys.save.encodeHTMLentities(this.footer_edit);
	this.footer_view =  RVwys.save.encodeHTMLentities(this.footer_view);

}

//		removeEle
		async removeEleHeader(){
			 this.header_edit =  RVwys.save.removeEle.headerEditmode(this.header_content);
			 var elm_view = this.header_content.clone();
			 this.header_view = RVwys.save.removeEle.headerViewmode(elm_view);
		}

		async removeEleContent(){
			 this.content_edit = await RVwys.save.removeEle.contentEditmode(this.content);
			 var elm_view = this.content.clone();
			 this.content_view = await RVwys.save.removeEle.contentViewmode(elm_view);
		}

		async removeEleFooter(){
			var elm_view = this.footer_content.clone();
			this.footer_edit = RVwys.save.removeEle.contentFooter(this.footer_content);
			this.footer_view = RVwys.save.removeEle.footerEmailView(elm_view);

		}


//		removeClass
		async removeClassHeader(){
			this.header_edit = RVwys.save.removeClass.headerEditmode(this.header_edit);
			this.header_view = RVwys.save.removeClass.headerViewmode(this.header_view);
		}

		async removeClassContent(){
			this.content_edit = RVwys.save.removeClass.contentEditmode(this.content_edit);
			this.content_view = RVwys.save.removeClass.contentViewmode(this.content_view);
		}

		async removeClassFooter(){
			this.footer_edit = this.footer_edit;
			this.footer_view = RVwys.save.removeClass.footerEmailView(this.footer_view);
		}


//	   replaceEle
	   async replaceEleHeader(){
		   this.header_edit = RVwys.save.replaceEle.headerEditmode(this.header_edit);
		   this.header_view = RVwys.save.replaceEle.headerViewmode(this.header_view);
	   }

	   async replaceEleContent(){

		   this.content_edit = RVwys.save.replaceEle.contentEditmode( this.content_edit);
		   this.content_view = RVwys.save.replaceEle.contentViewmode(this.content_view);
	   }




//	   replaceTxt
	   async replaceTxtHeader(){
		   this.header_edit = RVwys.save.replaceTxt.headerEditmode(this.header_edit);
		   this.header_view = RVwys.save.replaceTxt.headerViewmode( this.header_view);
	   }

	   async replaceTxtContent(elm){
		   this.content_edit = RVwys.save.replaceTxt.contentEditmode(this.content_edit );
			 //this.content_view = RVwys.save.replaceTxt.contentViewmode(this.content_view);
		   this.content_view = this.content_view.html(); // not replace [[URL]] in viewmode
	   }

	   async replaceTxtFooter(){
		   this.footer_edit = RVwys.save.replaceTxt.footerEmailEdit(this.footer_edit);
		   this.footer_view = RVwys.save.replaceTxt.footerEmailView(this.footer_view);
	   }


	}

	$(document).bind('designReady',function(e){
		// console.log(parent.$('#savemail'));
	});

	RVwys.save.getEmailContent = function(){
		this.header_edit;
		var content_center = $('<div>');
		  /** content **/
			   var page_content = (parent.$('#selected_body #editable_area_content').length > 0)
		     ? parent.$('#selected_body #editable_area_content').children().clone()
		     : parent.$('#frameBody').contents().find('#selected_body #editable_area_content').children().clone();

			page_content.each(function(){
				content_center.append($(this));
			});

		   return content_center;
	}


	RVwys.save.removeEle.footerEmailView = function(content){
		content.find('.rv-ribbon').remove();
		content.find('.imgsocial').remove();

		return content;
	}

	RVwys.save.removeClass.footerEmailView  = function(content){
		content.find('img').removeAttr('crossorigin');
		return content;
	}

	/** Footer replaceTxt **/
	RVwys.save.replaceTxt.footerEmailEdit = function(content){
		content = RVwys.save.replaceDisallow(content);
		content = content.html();

		return content

	}

	RVwys.save.replaceTxt.footerEmailView = function(content){
		content = RVwys.save.replaceDisallow(content);
		content = content.html();
		return content

	}




	RVwys.designViewAddEvent('mouseup',function(e){

	});


	RVwys.designViewAddEvent('keyup',function(e){

	});



})(jQuery);
